import React, { useState } from "react";

import { Grid } from "@mui/material";
import { AddCircleOutlineRounded as AddCircleOutlineRoundedIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import { Item } from "../../../../models/item";
import { useAppState } from "../../../../context/StateContext";
import { handleSaveConvertValue } from "../../../../util/converts";
import Button, { Color } from "../../../Form/Button";
import Input from "../../../Form/Input";
import Modal from "../../../Generic/Modal";

interface CreateItemModalProps {
  openModal: boolean;
  closeModal: () => void;
  onAddItem: (item: Item) => void;
}

const CreateItemModal = ({ openModal, onAddItem, closeModal }: CreateItemModalProps) => {
  const [name, setName] = useState<string>("");
  const [volume, setVolume] = useState<string>("");
  const { currentUser } = useAppState();

  const { t: translate } = useTranslation();

  const measurement = currentUser?.measurement?.code || currentUser?.company?.measurement?.code;

  const handleSubmit = (event: React.SyntheticEvent) => {
    event.preventDefault();
    const itemObject = {
      name,
      volume: handleSaveConvertValue(Number(volume), measurement),
      companyId: currentUser?.companyId,
    } as Item;

    onAddItem(itemObject);

    closeModal();
    handleClearFields();
  };

  const handleClearFields = () => {
    setName("");
    setVolume("");
  };

  return (
    <Modal
      open={openModal}
      handleClose={closeModal}
      title={translate("createItem")}
      showActionButtons={false}
    >
      <Grid container direction="row" alignItems="center" spacing={2}>
        <Grid item sm md={7} lg={7}>
          <Input
            name="name"
            placeholder="New Item"
            value={name}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => setName(event.target.value)}
          />
        </Grid>
        <Grid item sm md={2} lg={2}>
          <Input
            name="volume"
            placeholder={
              measurement?.includes("ft") ? `0 ${measurement || ""}` : `0.00 ${measurement || ""}`
            }
            value={volume}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              if (Number(event.target.value) >= 0) {
                setVolume(event.target.value);
              }
            }}
          />
        </Grid>
        <Grid item sm md={3} lg={3}>
          <Button
            fullWidth
            onClick={handleSubmit}
            startIcon={<AddCircleOutlineRoundedIcon />}
            disabled={name === "" || volume === ""}
            customColor={Color.SECONDARY}
          >
            {translate("add")}
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default CreateItemModal;
